define('app/models/customer_password',['app/setup'], function(takhfifan) {
  takhfifan.CustomerPassword = Backbone.Model.extend({

    validation: {
      current_password: {
          required: true,
          msg: i18n.t('current_password_missing')
      },
      password: {
        required: true,
        msg: i18n.t('password_missing')
      },
      confirm_password: {
        required: true,
        msg: i18n.t('password_confirm_missing')
      }
    },

    save: function(url) {
      var _this = this;
      var json = this.toJSON();

      // TODO: This is a stupid breaking of the DRY rule, we have
      //       to refactore this in the future
      $.post(url, json).done(function(data){
        if (!_.isNull(data)) {
          if (typeof data == 'string') {
            data = JSON.parse(data);
          }
          if (!_.isNull(data.error) && data.error == 1) {
            takhfifan.eventHub.trigger('customer_profile_password:error', [data.msg]);
          }
          else {
            takhfifan.eventHub.trigger('customer_profile:saved', data.customer_profile);
            takhfifan.eventHub.trigger('customer_profile_password:success', []);
          }
          if(!_.isNull(data.form_key))
          {
            takhfifan.eventHub.trigger('formkey', data.form_key);
          }
        }
      }).fail(function(data){
        takhfifan.eventHub.trigger(
          'customer_profile_password:error',
          [data.responseJSON.msg]
        );
      });
    }
  });
});

